module.exports = __webpack_public_path__ + "static/media/Icons- plaster.3e2337f8.svg";